<!-- Skeleton — composer only, so the modal shows something the moment a URL lands.
     Mirrors the real card's 20% / 80% split so nothing shifts when data arrives. -->
<div *ngIf="loading() && variant === 'composer'"
  class="mt-3 flex w-full overflow-hidden rounded-xl border border-gray-200 bg-gray-50 animate-pulse"
  style="height: 92px;">
  <div class="w-1/5 flex-shrink-0 bg-gray-200"></div>
  <div class="flex min-w-0 flex-1 flex-col justify-center gap-2 px-3">
    <div class="h-2.5 w-1/4 rounded bg-gray-200"></div>
    <div class="h-2.5 w-3/4 rounded bg-gray-200"></div>
    <div class="h-2.5 w-1/2 rounded bg-gray-200"></div>
  </div>
</div>

<ng-container *ngIf="preview() as data">
  <!-- Full-width, short row: image column at 20%, metadata takes the rest. -->
  <a [href]="data.url" target="_blank" rel="noopener noreferrer nofollow" (click)="onCardClick($event)"
    class="mt-3 flex w-full overflow-hidden rounded-xl border border-gray-200 bg-white no-underline transition-colors hover:border-gray-300 hover:bg-gray-50"
    style="height: 92px;">

    <!-- Left 20% — og:image, or the favicon when the page has none -->
    <div class="flex w-1/5 flex-shrink-0 items-center justify-center overflow-hidden bg-gray-100">
      <img *ngIf="data.image && !imageFailed()" [src]="data.image" [alt]="data.title || data.domain" loading="lazy"
        referrerpolicy="no-referrer" class="h-full w-full object-cover" (error)="onImageError()" />
      <!-- No og:image — let the favicon fill the column rather than float in it.
           `contain` keeps whatever aspect the icon has; the padding stops it
           bleeding into the border. -->
      <img *ngIf="(!data.image || imageFailed()) && data.favicon" [src]="data.favicon" alt="" loading="lazy"
        referrerpolicy="no-referrer" class="h-full w-full object-contain p-3" />
    </div>

    <!-- Right 80% — domain, title, description -->
    <div class="flex min-w-0 flex-1 flex-col justify-center px-3 py-2">
      <p class="truncate text-[11px] font-semibold uppercase tracking-wide text-gray-400">
        {{ displayDomain }}
      </p>
      <p *ngIf="data.title" class="line-clamp-1 text-sm font-semibold leading-snug text-gray-800">
        {{ data.title }}
      </p>
      <p *ngIf="data.description" class="mt-0.5 line-clamp-2 text-xs leading-snug text-gray-500">
        {{ data.description }}
      </p>
    </div>
  </a>

  <p *ngIf="variant === 'composer'" class="mt-1.5 text-xs text-gray-400">
    Link preview
  </p>
</ng-container>
